export default __webpack_public_path__ + "static/media/loader.ec9b7720.svg";